'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { Button } from '@/app/components/button';
import { Container } from '@/app/components/layouts/container';
import { Image } from '@/app/components/media/image';
import { useInView } from '@/app/hooks/useInView';
import { ConfigureFormContent } from '@/app/lcv/components/sections/calculator/configure/configure-form-content';
import styles from '@/app/lcv/components/sections/calculator/styles.module.css';
import { CALCULATOR_DATA_TEST } from '@/app/lcv/components/sections/calculator/tracking';
import type { CalculatorConfigProps } from '@/app/lcv/components/sections/calculator/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { formatPrice } from '@/app/utils/format';
export const CalculatorConfigure = t0 => {
  const $ = _c(31);
  const {
    listModelCategory,
    listModel: t1,
    model,
    ...props
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const listModel = t2;
  const sentinelRef = useRef(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      rootMargin: "-20px 0px 0px 0px",
      initialState: true,
      threshold: 0.1,
      once: false
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isSentinelInView = useInView(sentinelRef, t3);
  const showFixedButton = !isSentinelInView;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: CALCULATOR_DATA_TEST.calculator
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: "display-vehicle-details-panel"
    });
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: `${CALCULATOR_DATA_TEST.calculator}-vehicle-category`
    });
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: `${CALCULATOR_DATA_TEST.calculator}-vehicle-name`
    });
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== model.name) {
    t8 = <span className="text-center" {...t7}>{model.name}</span>;
    $[7] = model.name;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = "text-body-1 font-noto-bold text-center";
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = createDataAttributes({
      test: `${CALCULATOR_DATA_TEST.calculator}-vehicle-price`
    });
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = formatPrice(props.price);
  let t12;
  if ($[10] !== t10 || $[11] !== t11) {
    t12 = <span className={t9} {...t10}>{t11}</span>;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = createDataAttributes({
      test: "customize-vehicle-payment-panel"
    });
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== listModel || $[15] !== listModelCategory || $[16] !== model || $[17] !== props) {
    t14 = <ConfigureFormContent listModelCategory={listModelCategory} listModel={listModel} model={model} sentinelRef={sentinelRef} {...props} />;
    $[14] = listModel;
    $[15] = listModelCategory;
    $[16] = model;
    $[17] = props;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = !showFixedButton;
  let t16;
  if ($[19] !== showFixedButton || $[20] !== t15) {
    t16 = cn("property-opacity-translate ease-bezier fixed bottom-0 left-0 z-10 hidden w-full bg-white px-6 py-4 lg:sticky lg:block lg:translate-y-0 lg:opacity-100 lg:shadow-xl", styles.calculatorFixedButton, {
      "translate-y-full opacity-0": t15,
      "translate-y-0": showFixedButton
    });
    $[19] = showFixedButton;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const t17 = props.onSubmit;
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = createDataAttributes({
      test: "button-confirm-calculator"
    });
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== props.onSubmit) {
    t19 = <Button width="full" onClick={t17} {...t18}>คำนวณ</Button>;
    $[23] = props.onSubmit;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t16 || $[26] !== t19) {
    t20 = <div className={t16}>{t19}</div>;
    $[25] = t16;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t14 || $[29] !== t20) {
    t21 = <div className="relative w-full bg-white lg:shrink-0 lg:grow-0 lg:basis-119 lg:pb-20" {...t13}>{t14}{t20}</div>;
    $[28] = t14;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  return <section className="bg-silver-50 relative overflow-hidden" {...t4}><div className="lg:h-screen-header relative block w-full overflow-hidden lg:flex lg:max-h-205"><div className="relative max-w-full self-center py-10 sm:py-12 lg:grow lg:pb-16" {...t5}><Container><div className="relative mx-auto grid max-w-200 gap-y-3">{!!props.color && <Image priority={true} src={props.color.front?.url ?? ""} alt={props.modelCategory?.nameTh} width={600} height={338} sizes="(min-width: 1024px) 800px, 90vw" aspectRatio="aspect-16-9" />}<div className="grid justify-center gap-y-1"><span className="text-center" {...t6}>{props.modelCategory?.nameTh}</span>{t8}{t12}</div></div></Container></div>{t21}</div></section>;
};